export const FLOW_NAME = {
  STEPPER_FORM: 'StepperForm',
};

export const API_STATUS = {
  SUCCESS: 'success',
  VALIDATION_ERROR: 'validationError',
  PENDING: 'pending',
  UNAUTHORIZED: 'unauthorized',
  SERVER_ERROR: 'serverError',
  BAD_REQUEST: 'badRequest',
};
